import { RSAA } from 'redux-api-middleware';
import { FETCH_ALL } from './types';

const viralApiUrl = process.env.VIRAL_CLIPS_API;

const viralFetchAllApiRequest = ({ limit = 6, viralSlug = null } = {}) => ({
  [RSAA]: {
    endpoint: `${viralApiUrl}/v2/trending?limit=${limit}&clip=${viralSlug}`,
    method: 'GET',
    credentials: 'same-origin',
    injectParams: false,
    types: [
      {
        type: FETCH_ALL.REQUEST,
        meta: {
          params: {
            limit,
          },
        },
      },
      {
        type: FETCH_ALL.SUCCESS,
        payload: async (action, state, res) => {
          const data = await res.json();
          const { clip, clips, meta } = data;
          return {
            clip,
            clips,
            meta,
          };
        },
        meta: {
          params: {
            limit,
          },
        },
      },
      {
        type: FETCH_ALL.FAILURE,
        meta: {
          params: {
            limit,
          },
        },
      },
    ],
  },
});

const requests = {};
const alreadyRequested = (params) => requests[JSON.stringify(params)];
const setRequested = (params) => {
  requests[JSON.stringify(params)] = true;
};

export const viralFetchAllApiRequestAction = ({ limit = 6, viralSlug } = {}) => async (
  dispatch,
) => {
  const params = { limit, viralSlug };
  if (alreadyRequested(params)) {
    return;
  }

  setRequested(params);
  await dispatch(viralFetchAllApiRequest(params));
};
